import { Box, TextField, theme } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ToolRoomContainer = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  p: { sm: '400' },
  alignItems: { sm: 'center' },
})`
  width: 100%;
  height: 67px;
`;
export const ToolRoomEditContainer = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
  mt:{sm:'300'}
})`
  width: 100%;
  box-shadow:0px 0px 4px 4px ${theme.colors.neutral[200]};
  border-radius: 4px;
  height: 110px;
`;
export const SepartorStyled = styled(Box)`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;
export const SideView = styled(Box)`
  ${({ theme }) => css`
    width: 7px;
    background-color: ${theme.colors.neutral[800]};
    height: 110px;
    border-radius: 3px;
  `}
`;
export const ToolRoomChildContainer = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
})<{ width: string }>`
  width: ${({ width }) => width};
`;
export const ColumnContainer = styled(Box)<{ width: string }>`
  ${({ width }) => css`
    width: ${width};
  `}
`;
export const TextFieldStyled = styled(TextField)`
  height: ${theme.spacings[1000]};
`;
